
    // API_URL: "https://api.areabuddy.com",
    export const API_URL = "https://api.vyntezbuddy.com";
    export const REACT_APP_GOOGLE_MAPS_API_KEY = "AIzaSyB7g0J8k1X6Z2j3K4l5m6n7o8p9q0r1s2t";

